/**
 * ReportsPage - Страница дашбордов и отчётов
 *
 * Доступ: ADMIN, MANAGER, VIEWER
 * Нет доступа: SALES, TEACHER
 */

import React from 'react';
import { Box, Stack, Title, Text, Grid } from '@mantine/core';
import tokens from '../theme/designTokens';
import FunnelChartWidget from '../components/Reports/widgets/FunnelChartWidget';
import ElementStatsWidget from '../components/Reports/widgets/ElementStatsWidget';

const ReportsPage = () => {
  return (
    <Box px="md" py="md">
      <Stack gap="lg">
        {/* Заголовок страницы */}
        <Box>
          <Title order={2} style={{ color: tokens.colors.brand.primary }}>
            Дашборды
          </Title>
          <Text c="dimmed" size="sm">
            Аналитика и отчёты по работе с организациями
          </Text>
        </Box>

        {/* Сетка виджетов */}
        <Grid gutter="lg">
          {/* Виджет воронки - полная ширина */}
          <Grid.Col span={12}>
            <FunnelChartWidget />
          </Grid.Col>

          {/* Виджет статистики по элементам - полная ширина */}
          <Grid.Col span={12}>
            <ElementStatsWidget />
          </Grid.Col>
        </Grid>
      </Stack>
    </Box>
  );
};

export default ReportsPage;
